import * as Yup from "yup";

export const validationSchema = Yup.object().shape({
  submissionNumber: Yup.string().required("This field is required!"),
  currentCarrier: Yup.string().required("This field is required!"),
  agency: Yup.string().required("This field is required!"),
  company: Yup.string().required("This field is required!"),
  premium: Yup.string().required("This field is required!"),
  renewalDate: Yup.date().required("This field is required!"),
});

